import React from 'react';
import Header from './../../Header';
import Footer from './../../Footer';
import Loader from './../../Loader';
import Menu from './../../Menu';
import ProjectNav from './../ProjectNav';
import { fetchMenu } from "./../../../actions/menuActionCreators";
import { fetchProjects } from "./../../../actions/projectActionCreators";
import { fetchJournals } from "./../../../actions/journalActionCreators";
import { fetchOptions } from "./../../../actions/optionActionCreators";
import ScrollNav from './../../ScrollNav';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';

import {
    NavLink,
    Link
} from 'react-router-dom'

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true
        }
    }
    componentDidMount() {
		ReactGA.pageview('/projects');
        Promise.all([
            this.props.dispatch(fetchMenu('menu')),
            this.props.dispatch(fetchProjects()),
            this.props.dispatch(fetchJournals()),
            this.props.dispatch(fetchOptions()),
        ]).then(() => {
            this.setState({
                pageLoading: false
            })
        });
    }

    render() {
		let { menu } = this.props.menu;

        let projects = this.props.projects && Object.keys(this.props.projects.data).length ? this.props.projects.data.all : [] ;
        let projectsData = projects.map((item, key) => {
            return (
                <Link to={`${process.env.PUBLIC_URL}/project/${item.post_name}`} className="project-item" key={key}>
                    <figure><img src={item.thumb_image.url} alt={item.post_title} title={item.post_title}/></figure>
                    <figcaption>
                        <h5 className="head">{item.post_title}</h5>
                        {
                            item.post_excerpt != '' &&
                                <div className="desc">
                                    {item.post_excerpt}
                                </div>
                        }
                        <span className="btn-arw right">Read More</span>
                    </figcaption>
                </Link>
            )
        })
        return (
			<div className="fullW">
                <Helmet>
                    <title>Lelay Architects | Projects</title>
                </Helmet>
                <Header {...this.props} />
                <main className="ll__projects">
                    {this.state.pageLoading &&
						<Loader />
					}
                    <section>
                        <div className="main-container">
                            <ProjectNav {...this.props} />
                            <div className="grid-2">
                                {projectsData}
                            </div>
                        </div>
                    </section>
                </main>
                {menu.primary &&
                    <Menu {...this.props} />
                }
                <Footer {...this.props} />
                <ScrollNav/>
            </div>
        );
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Projects/List/index.js